import React from 'react'

interface DuplicateCertificateModalProps {
  filename: string
  onReplace: () => void
  onKeepBoth: () => void
  onCancel: () => void
}

export const DuplicateCertificateModal: React.FC<DuplicateCertificateModalProps> = ({
  filename,
  onReplace,
  onKeepBoth,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        {/* Header */}
        <div className="border-b border-[var(--color-border)] px-6 py-4">
          <h2 className="text-xl font-semibold text-[var(--color-text-primary)]">
            Certificat existant détecté
          </h2>
        </div>

        {/* Body */}
        <div className="px-6 py-6">
          <p className="text-[var(--color-text-primary)] mb-4">
            Un certificat avec le nom <strong>{filename}</strong> existe déjà.
          </p>
          <p className="text-[var(--color-text-secondary)] mb-6">
            Que souhaitez-vous faire ?
          </p>
        </div>

        {/* Footer */}
        <div className="border-t border-[var(--color-border)] px-6 py-4 flex flex-col gap-2">
          <button
            type="button"
            onClick={onReplace}
            className="w-full px-4 py-2 bg-[var(--color-primary)] text-white rounded-lg hover:bg-[var(--color-primary)]/90 transition-colors"
          >
            Remplacer l'ancien certificat
          </button>
          <button
            type="button"
            onClick={onKeepBoth}
            className="w-full px-4 py-2 bg-[var(--color-gray-100)] text-[var(--color-text-primary)] rounded-lg hover:bg-[var(--color-gray-200)] transition-colors"
          >
            Garder les deux (renommer automatiquement)
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="w-full px-4 py-2 border border-[var(--color-border)] text-[var(--color-text-primary)] rounded-lg hover:bg-[var(--color-gray-100)] transition-colors"
          >
            Annuler (garder l'ancien uniquement)
          </button>
        </div>
      </div>
    </div>
  )
}

